var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { WellforcePartner } from './WellforcePartner';
import { millCityMedPrimaryCareLocation } from '../../../../clearstep/util/Wellforce/WellforcePrimaryCareLocations';
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-unused-vars */
var MillCityMedWellforcePartner = /** @class */ (function (_super) {
    __extends(MillCityMedWellforcePartner, _super);
    function MillCityMedWellforcePartner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MillCityMedWellforcePartner.prototype.virtualVisitOptions = function () {
        return this.wellforceCta({
            cta: 'Schedule a virtual visit',
            url: MillCityMedWellforcePartner.bookApptURL,
        });
    };
    MillCityMedWellforcePartner.prototype.primaryCareOption = function () {
        return this.wellforcePrimaryCare('Schedule an appointment', MillCityMedWellforcePartner.bookApptURL, millCityMedPrimaryCareLocation);
    };
    MillCityMedWellforcePartner.prototype.urgentCareOption = function () {
        return this.wellforceUrgentCare('Schedule an appointment', MillCityMedWellforcePartner.bookApptURL, millCityMedPrimaryCareLocation);
    };
    MillCityMedWellforcePartner.prototype.homeCareProviderOption = function () {
        return this.wellforceHomeCareProviderOption('Schedule an appointment', MillCityMedWellforcePartner.bookApptURL, millCityMedPrimaryCareLocation);
    };
    MillCityMedWellforcePartner.prototype.emergencyAdditionalGuidanceOption = function () {
        return this.wellforceAdditionalGuidanceOption('Schedule an appointment', MillCityMedWellforcePartner.bookApptURL, millCityMedPrimaryCareLocation);
    };
    MillCityMedWellforcePartner.prototype.covidRelatedEmergencyResponse = function () {
        return this.wellforceCovidRelatedEmergencyResponse();
    };
    MillCityMedWellforcePartner.prototype.covidDoctorTriageResponse = function (options) {
        if (options.hasTelemedicineSupport) {
            return this.wellforceCovidDoctorTriageResponse({
                cta: 'Schedule a virtual visit',
                url: MillCityMedWellforcePartner.bookApptURL,
                partnerName: 'Mill City Med',
            });
        }
        return null;
    };
    MillCityMedWellforcePartner.bookApptURL = 'https://millcitymed.com/appointments';
    return MillCityMedWellforcePartner;
}(WellforcePartner));
export { MillCityMedWellforcePartner };
